var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.092,
    height: 15.385,
    viewBox: "0 0 23.092 15.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M0,213.209v5.976A3.116,3.116,0,0,0,3.116,222.3h16.86a3.116,3.116,0,0,0,3.116-3.116v-5.976a.542.542,0,0,0-.542-.542H.542A.542.542,0,0,0,0,213.209ZM5.766,217H4.32a.948.948,0,1,1,0-1.9H5.766a.948.948,0,1,1,0,1.9Z",
    transform: "translate(0 -206.917)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M23.092,88.646v-.2a3.116,3.116,0,0,0-3.116-3.116H3.116A3.116,3.116,0,0,0,0,88.45v.2a.542.542,0,0,0,.542.542H22.55A.542.542,0,0,0,23.092,88.646Z",
    transform: "translate(0 -85.334)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/Payment.6db5062d00ffb554edff88d6d9a263c3.svg";
export { ForwardRef as ReactComponent };